// Lightweight crash + error monitoring. No-ops if VITE_SENTRY_DSN is unset.
import * as Sentry from '@sentry/react';

let started = false;

export function initMonitoring() {
  if (started) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.0,
    sendDefaultPii: false,
  });
  started = true;
}

export function captureError(err: unknown, context?: Record<string, unknown>) {
  try {
    if (started) Sentry.captureException(err, { extra: context });
    // Always log so dev sees it
    console.error('[jozori]', err, context);
  } catch {}
}

export function setUserContext(user: { id: string; email?: string } | null) {
  if (!started) return;
  if (user) Sentry.setUser({ id: user.id, email: user.email });
  else Sentry.setUser(null);
}
